<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['field_name', 'department', 'com_name', 'rank', 'writer_name', 'date', 'updated_at']"
      :typeslabel="{
        date: '최초 작성일',
        updated_at: '최종 수정일',
      }"
    />

    <!-- 안전검사 기계·기구 보유현황-->
    <table-module1020
      title="안전검사 기계·기구 보유현황"
      v-model="form.보유현황"
      :is-print="isPrint"
      :readonly="board.readonly"
      class="mt-8"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-8" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableCustom from "@/components/TableCustom.vue";
import TableModule1020 from "@/views/boards/single-page/1020/TableModule1020.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    TableModule1020,
    TableCustom,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        fileList: [],
        보유현황: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addRow() {
      this.form.보호구지급대장.push({ id: Math.random().toString(36).substr(2, 9)});
      this.allCheck = false;
    },
    deleteRow() {
      const selectedRow = this.form.보호구지급대장.filter((row) => row.selected);
      if (selectedRow.length === 0) {
        return;
      }

      this.form.보호구지급대장 = this.form.보호구지급대장.filter((row) => !row.selected);
      this.allCheck = false;
    },
    onClickAllCheckBox() {
      setTimeout(() => {
        if (this.allCheck) {
          this.form.보호구지급대장.forEach((row) => {
            row.selected = true;
          });
        } else {
          this.form.보호구지급대장.forEach((row) => {
            row.selected = false;
          });
        }
      }, 100);
    },
  },
  computed: {
    checkedSelectedItem() {
      return this.form.보호구지급대장.filter((row) => row.selected).length === 0;
    },
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        padding: 5px;
        border: solid #cdcdcd 1px;

        div {
          align-items: center;
        }
      }
    }
  }
}
</style>
